import { useNavigate } from "react-router-dom";

import ICONS from "../../../assets/Icons";

import ReimbursementTxnRequestDetail from "../../../containers/ReimbursementRequest/ReimbursementTxnRequestDetail";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";

function ReimbursementReqTxnDetailsPopup({
  closePopup,
  reimburse_request_id,
  type,
  RequestHeader,
  flow,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle={RequestHeader}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        isfullViewrequired={true}
        smallPopupHeader={"Are you sure you want to leave this page?"}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closePopup();
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${reimburse_request_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closePopup}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <ReimbursementTxnRequestDetail
          reimburse_request_id={reimburse_request_id}
          txn_id={reimburse_request_id}
          type={type}
          closePopup={closePopup}
          flow={flow}
          isPopup
        />
      </LargePopupRedirect>
    </div>
  );
}

export default ReimbursementReqTxnDetailsPopup;
